// The starting-attitude options an impact can carry. Named for the
// stakeholder groups they were first defined on.

export const STARTING_ATTITUDES = [
    { value: "champion", label: "Champion" },
    { value: "neutral", label: "Neutral" },
    { value: "resistant", label: "Resistant" },
    { value: "unknown", label: "Unknown" },
];

// There are no demographic constants here any more. The mapping editor and the
// project's demographic question/option registry it fed are gone: respondents
// are placed in stakeholder groups directly (raw_input['memberships']), so a
// group no longer describes a demographic slice and the drawer has nothing to
// choose one from.
